export default __webpack_public_path__ + "static/media/male-ava.4e88afcf.png";